module.exports = __webpack_public_path__ + "img/bun.e8a7da24.jpg";